import { WhatsAppIcon } from "@/components/site/WhatsAppIcon";
import { Reveal } from "@/components/site/Reveal";
import { IMG, waLink, onWhatsApp } from "@/lib/site";

const STATS = [
  { v: "Desde 2019", l: "No mercado" },
  { v: "24H", l: "Atendimento" },
  { v: "Jundiaí", l: "+ Região" },
  { v: "Carros", l: "e Motos" },
];

export const About = () => {
  return (
    <section id="sobre" className="relative py-24 md:py-32">
      <div className="container-x grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <Reveal className="relative order-2 lg:order-1">
          <div className="relative aspect-[4/3] overflow-hidden rounded-sm border border-white/10">
            <img
              src={IMG.about}
              alt="Citroën C3 Picasso sobre a plataforma do guincho DG Guinchos em Jundiaí SP"
              loading="lazy"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-px bg-white/10 mt-4 border border-white/10">
            {STATS.map((s) => (
              <div key={s.v} className="bg-surface p-4 text-center">
                <div className="font-display text-2xl md:text-3xl font-black text-brand leading-none">{s.v}</div>
                <div className="mt-1 text-[11px] uppercase tracking-widest text-zinc-400 font-semibold">{s.l}</div>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.1} className="order-1 lg:order-2">
          <span className="text-brand font-display text-lg font-bold uppercase tracking-[0.2em]">Sobre Nós</span>
          <h2 className="mt-3 font-display text-4xl md:text-6xl font-black text-white leading-[0.92]">
            DG Guinchos Jundiaí
          </h2>
          <div className="mt-6 space-y-4 text-lg text-zinc-400">
            <p>A DG Guinchos atua em Jundiaí e região oferecendo serviços de guincho, reboque e transporte de veículos.</p>
            <p>Desde 2019, buscamos oferecer um atendimento ágil, seguro e responsável, cuidando do veículo durante todo o processo de remoção e transporte.</p>
            <p>Atendemos carros e motos, tanto em situações emergenciais quanto em transportes previamente programados.</p>
            <p className="text-white font-semibold">Precisou de guincho em Jundiaí ou região? Entre em contato com a DG Guinchos.</p>
          </div>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="about-cta"
            onClick={() => onWhatsApp("sobre")}
            className="mt-8 inline-flex items-center gap-2.5 bg-wapp hover:bg-wapp-hover text-black font-display font-bold uppercase tracking-wider text-lg px-8 py-4 rounded-sm transition-all active:scale-95"
          >
            <WhatsAppIcon className="h-6 w-6" /> Falar com a DG Guinchos
          </a>
        </Reveal>
      </div>
    </section>
  );
};
